import { WindowsOutlined } from "@ant-design/icons";
import { Building, IdCard, Proportions, ChevronRight } from "lucide-react";

export const windowNavigation = [
    {
        key: "/windows",
        icon: <WindowsOutlined className="icon" />,
        label: "Windows EPS",
        navigate: "/windows",
        expandIcon: ({ isOpen }) => (
            <ChevronRight
                className={`icon transition-transform duration-200 ${isOpen ? 'rotate-90' : ''}`}
            />
        ),
        children: [
            { key: "/windows/endpoints", label: "Windows Endpoints", navigate: "/windows/endpoints", },
            { key: "/windows/endpointPolicies", label: "Endpoint Policies", navigate: "/windows/endpointPolicies", },
            { key: "/windows/requestLogs", label: "Request Logs", navigate: "/windows/requestLogs", },
            { key: "/windows/auditLogs", label: "Audit Logs", navigate: "/windows/auditLogs", },
            { key: "/windows/accountLockoutEvents", label: "Account Lockout Events", navigate: "/windows/accountLockoutEvents", }
        ]
    }
]


export const dpaNavigation = [
    {
        key: "/windows",
        icon: <Proportions className="icon" />,
        label: "DPA PAM",
        navigate: "/windows",
        expandIcon: ({ isOpen }) => (
            <ChevronRight
                className={`icon transition-transform duration-200 ${isOpen ? 'rotate-90' : ''}`}
            />
        ),
        children: [
            { key: "/windows/jit", label: "JIT Access Policies", navigate: "/windows/jit" },
            { key: "/windows/jitConnections", label: "JIT Connections", navigate: "/windows/jitConnections" }
        ]
    }
]


export const testingPamNavigation = [
    {
        key: "/workloadIdentity",
        icon: <IdCard className="icon" />,
        label: "Workload Identity",
        navigate: "/workloadIdentity",
        children: [
            { key: "/workloadIdentity", label: "Workload Identity", navigate: "/workloadIdentity" }
        ]
    }
]

export const tenantConfigNavigation = [
    {
        key: "/tenantConfig",
        icon: <Building className="icon" />,
        label: "Tenant Config",
        navigate: "/tenantConfig",
    }
]



